import { g as t } from "./global.js";
import { f as o } from "./function-apply.js";
import { f as e } from "./function-bind-context.js";
import { i as n } from "./is-callable.js";
import { h as s } from "./has-own-property.js";
import { f as i } from "./fails.js";
import { h as r } from "./html.js";
import { a } from "./array-slice.js";
import { d as m } from "./document-create-element.js";
import { v as c } from "./validate-arguments-length.js";
import { e as f } from "./engine-is-ios.js";
import { e as p } from "./engine-is-node.js";
var l,
  u,
  d,
  g,
  h = t.setImmediate,
  j = t.clearImmediate,
  v = t.process,
  w = t.Dispatch,
  y = t.Function,
  M = t.MessageChannel,
  b = t.String,
  x = 0,
  C = {},
  k = "onreadystatechange";
i(function () {
  l = t.location;
});
var E = function E(t) {
    if (s(C, t)) {
      var o = C[t];
      delete C[t], o();
    }
  },
  I = function I(t) {
    return function () {
      E(t);
    };
  },
  L = function L(t) {
    E(t.data);
  },
  S = function S(o) {
    t.postMessage(b(o), l.protocol + "//" + l.host);
  };
h && j || (h = function h(t) {
  c(arguments.length, 1);
  var e = n(t) ? t : y(t),
    s = a(arguments, 1);
  return C[++x] = function () {
    o(e, void 0, s);
  }, u(x), x;
}, j = function j(t) {
  delete C[t];
}, p ? u = function u(t) {
  v.nextTick(I(t));
} : w && w.now ? u = function u(t) {
  w.now(I(t));
} : M && !f ? (g = (d = new M()).port2, d.port1.onmessage = L, u = e(g.postMessage, g)) : t.addEventListener && n(t.postMessage) && !t.importScripts && l && "file:" !== l.protocol && !i(S) ? (u = S, t.addEventListener("message", L, !1)) : u = k in m("script") ? function (t) {
  r.appendChild(m("script"))[k] = function () {
    r.removeChild(this), E(t);
  };
} : function (t) {
  setTimeout(I(t), 0);
});
var T = {
  set: h,
  clear: j
};
export { T as t };